<template>
  <b-container class="chat-box">
    <b-row>
      <b-col cols="12" lg="10" class="mx-auto">
        <div
          v-for="(msg, msgidx) in messages"
          :key="msgidx"
          class="chat-record mt-2"
        >
          <ChatMessageComponent
            :style="{
              '--main-color': mainColor,
              '--secondary-color': mainColor,
            }"
            :initMsg="msg"
            :key="msgidx"
            :msgidx="msgidx"
            :ref="`msgRef-${msg.name}`"
            :context="context"
            :condition="condition"
            @select-card="handleCardClick"
            @increase="handleIncrease"
            @decrease="handleDecrease"
            @continue="continueChat"
            @scroll-to-bottom="scrollToBottom"
            @scroll-to-msg="scrollToMsg"
            @select-checkbox="handleCheckbox"
            @set-text-input="setTextInput"
            @selector-change="handleSelectorChange"
            @update-condition="updateCondition"
          />
          <div>
            <b-row
              v-if="msg.isFinal"
              class="w-100 reset-button py-2 m-1"
              @click="resetChat"
            >
              <b-col>Reiniciar chat</b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <!-- <b-col col lg="2" class="d-none d-sm-block">
          <b-card
            bg-variant="light"
            title="Costo:"
            style="position: sticky; top: 4em"
          >
            <b-card-text>
              <b>{{ cost }}</b>
              <b-img :src="appleIcon" width="22px" class="pl-1 mb-2 mx-0" />
            </b-card-text>
          </b-card>
        </b-col> -->
    </b-row>
  </b-container>
</template>
<script>
import ChatMessageComponent from "./ChatMessageComponent.vue";
import CreateMaterial from "@/components/botpie-assistant/CreateMaterial";
import EurekaTable from "@/components/redpie/miscellaneous/EurekaTable";
import informationService from "@/services/informationService";
import customTestService from "@/services/customTestService";
import chatBotService from "@/services/chatBotService";
import userService from "@/services/userService";
import PlanificationTable from "./PlanificationTable";
import MissionsView from "@/components/utopie/miscellaneous/MissionsView";
import { MEETING_OPTION, meetingQuestion } from "./meetingOffer";
import { REFERRAL_OPTIONS, referralQuestions } from "./referralOffer";
import { ensureReferralRewards } from "./referralRewards";
import { usesLine, usesCardClass, spendsUses } from "./serviceUses";
import { scrollToElementTop, scrollToPageBottom } from "@/utils/scrollToTop";
import { skipAutoScroll } from "./chatScroll";
const SERVICE = "planification";
// import materialDocumentSocket from "@/mixins/materialDocumentSocket";

export default {
  components: {
    ChatMessageComponent,
    CreateMaterial,
    EurekaTable,
    MissionsView,
    PlanificationTable,
  },
  name: "ChatBotMaterials",
  // mixins: [materialDocumentSocket],
  data() {
    return {
      mainColor: "#20b2aa",
      secondaryColor: "#20b2aa",
      currentQuestionIndex: "",
      condition: "",
      context: { 
        service: "Planificaciones",
        "type": {
          title: "Diversificado",
          name: "Actividades con Diseño Universal (DUA)",
          cols: "col-6",
          bootstrap_classes: "text-center",
          isSelected: true,
          option: "accurate",
          nextQuestionIndex: "period",
        },
        "period": {
          title: "Planificación",
          name: "Diaria",
          cols: "col-6",
          isSelected: true,
          bootstrap_classes: "text-center",
          option: "daily",
          nextQuestionIndex: "curso",
        }
      },
      answers: {
        "type": {
          title: "Diversificado",
          name: "Actividades con Diseño Universal (DUA)",
          cols: "col-6",
          bootstrap_classes: "text-center",
          isSelected: true,
          option: "accurate",
          nextQuestionIndex: "period",
        },
        "period": {
          title: "Planificación",
          name: "Diaria",
          cols: "col-6",
          isSelected: true,
          bootstrap_classes: "text-center",
          option: "daily",
          nextQuestionIndex: "curso",
        }
      },
      selectedCard: null,
      messages: [],
      prices: {},
      cost: 0,
      appleIcon: require("@/assets/img/icono-manzana.svg"),
      starIcon: require("@/assets/img/icono-estrella.svg"),
      copyIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_link.svg"),
      backIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Íconos_atrás.svg"),
      reviewIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_revisar.svg"),
      types: ["text", "button", "quickReplies"],
      questions: {
        welcomeMessage: {
          name: "welcomeMessage",
          vueContext: this,
          text() {
            return `👋 Hola ${this.vueContext.$store.state.login.first_name}! 
            Bienvenido al módulo de creación de planificaciones.<br/>
            ${usesLine(SERVICE)}<br/>
            ¿Qué te gustaría hacer?`;
          },
          type: "options",
          answersLoaded: false,
          single_choice: true,
          answers: [],
          alreadySeen: [],
          process_dic: [
            {
              label: "Conocer más detalles",
              nextIndex: "details",
            },
            {
              label: "Ver el tutorial",
              nextIndex: "video",
            },
            {
              label: "Recibir una cotización para mi colegio",
              nextIndex: "bill",
            },
            {
              label: "Crear una planificación",
              nextIndex: "curso",
            },
            // Las formas de conseguir usos van en este orden a propósito:
            // invitar primero (es la que más usos reparte y trae gente nueva),
            // luego declarar quién te invitó, y después el resto.
            ...REFERRAL_OPTIONS,
            {
              label: "Comprar usos",
              option: "redirect",
              redirect: "/utopie#/buy_product/planification"
            },
            {
              label: "Ver misiones y ganar usos",
              nextIndex: "missions",
            },
            MEETING_OPTION,
          ],
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                this.process_dic.forEach((ans) => {
                  if (ans.condition) {
                    if (ans.condition()) {
                      this.answers.push({
                        name: ans.label,
                        isSelected: false,
                        class: "col-md-7 col-12 my-2",
                        bootstrap_classes: "text-left px-2 font-weight-bold",
                        nextQuestionIndex: ans.nextIndex,
                        option: ans.option,
                        redirect: ans.redirect,
                        cardClass: usesCardClass(ans, SERVICE),
                      });
                    }
                  } else {
                    this.answers.push({
                      name: ans.label,
                      isSelected: false,
                      class: "col-md-7 col-12 my-2",
                      bootstrap_classes: "text-left px-2 font-weight-bold",
                      nextQuestionIndex: ans.nextIndex,
                      option: ans.option,
                      redirect: ans.redirect,
                      cardClass: usesCardClass(ans, SERVICE),
                    });
                  }
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
            // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
          },
        },
        mainMessage: {
          name: "mainMessage",
          text() {
            if (!this.answers.length) {
              return "Has visto todos los mensajes disponibles! Recarga la página para comenzar de nuevo.";
            }
            return `${usesLine(SERVICE)}<br/>
                Ahora, <strong>¿Qué quieres hacer?</strong>`;
          },
          type: "options",
          answersLoaded: false,
          single_choice: true,
          isMain: true,
          vueContext: this,
          answers: [],
          alreadySeen: [],
          process_dic: [
            {
              label: "Conocer más detalles",
              nextIndex: "details",
            },
            {
              label: "Ver el tutorial",
              nextIndex: "video",
            },
            {
              label: "Recibir una cotización para mi colegio",
              nextIndex: "bill",
            },
            {
              label: "Crear una planificación",
              nextIndex: "curso",
            },
            // Las formas de conseguir usos van en este orden a propósito:
            // invitar primero (es la que más usos reparte y trae gente nueva),
            // luego declarar quién te invitó, y después el resto.
            ...REFERRAL_OPTIONS,
            {
              label: "Comprar usos",
              option: "redirect",
              redirect: "/utopie#/buy_product/planification"
            },
            {
              label: "Ver misiones y ganar usos",
              nextIndex: "missions",
            },
            MEETING_OPTION,
            {
              label: "Reiniciar chat",
              nextIndex: "reset",
            }
          ],
          getAnswers(context) {
            this.answers = [];
            return new Promise((resolve) => {
              this.process_dic.forEach((ans) => {
                // Ya usada = ya leída: no se vuelve a ofrecer. La única que
                // repite es la acción del servicio.
                if (!(ans.nextIndex in context) || spendsUses(ans)) {
                  if (ans.condition) {
                    if (ans.condition()) {
                      this.answers.push({
                        name: ans.label,
                        isSelected: false,
                        class: "col-md-7 col-12 my-2",
                        bootstrap_classes: "text-left px-2 font-weight-bold",
                        nextQuestionIndex: ans.nextIndex,
                        redirect: ans.redirect,
                        cardClass: usesCardClass(ans, SERVICE),
                      });
                    }
                  } else {
                    this.answers.push({
                      name: ans.label,
                      isSelected: false,
                      class: "col-md-7 col-12 my-2",
                      bootstrap_classes: "text-left px-2 font-weight-bold",
                      nextQuestionIndex: ans.nextIndex,
                      redirect: ans.redirect,
                      cardClass: usesCardClass(ans, SERVICE),
                    });
                  }
                }
              });
              this.answersLoaded = true;
              resolve(this.answers);
            });
          },
          routine() {
            console.log("routine");
            // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
          },
        },
        details: {
          name: "details",
          text: "¡Perfecto! Aquí te muestro los detalles de las planificaciones que puedes generar",
          type: "informative",
          nextQuestionIndex: "mainMessage",
          answers: [],
          process_dic: [
            {
              title: "Planificaciones diversificadas (DUA)",
              text: "Generamos planificaciones de clase basadas en el Diseño Universal para el Aprendizaje, garantizando actividades inclusivas para todos los estudiantes.",
              image: require("@/assets/img/planification_sale/PNG/Planificaciones_6_diseño universal@4x.png"),
              height: "200",
            },
            {
              title: "Cobertura curricular completa",
              text: "Cubrimos los Objetivos de Aprendizaje (OA) del currículum chileno desde Pre-kinder hasta 4° medio para Lenguaje, Matemáticas, Historia, Música y más.",
              image: require("@/assets/img/planification_sale/PNG/Planificaciones_5_formatos@4x.png"),
              height: "300",
            },
            {
              title: "Listas en segundos",
              text: "Sólo eliges curso, asignatura, OA e indicadores y la planificación se genera automáticamente.",
              image: require("@/assets/img/planification_sale/PNG/Planificaciones_4_en segundos@4x.png"),
              height: "200",
            },
            {
              title: "Basadas en la Taxonomía de Bloom",
              text: "Las actividades respetan los distintos niveles cognitivos para asegurar un aprendizaje progresivo y significativo.",
              image: require("@/assets/img/planification_sale/PNG/Planificaciones_7_taxonomía de bloom@4x.png"),
              height: "150",
            },
            {
              title: "Múltiples formatos disponibles",
              text: "Planificación diaria, semanal o mensual según las necesidades de tu colegio o tu gestión de aula.",
              image: require("@/assets/img/planification_sale/PNG/Planificaciones_2_tabla planif@4x.png"),
              height: "800",
            },
            {
              title: "Descárgalas a tu PC",
              text: "Una vez generadas puedes descargar la planificación en formato editable para imprimir o seguir trabajándola.",
              image: require("@/assets/img/planification_sale/PNG/Planificaciones_8_descárgala a tu pc@4x.png"),
              height: "200",
            },
          ],
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                this.process_dic.forEach((ans) => {
                  this.answers.push({
                    title: ans.title,
                    text: ans.text,
                    image: ans.image,
                    height: ans.height,
                    cellHeight: ans.cellHeight,
                    class: "col-12 col-md-12 mb-2",
                  });
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
          },
        },
        bill: {
          name: "bill",
          text: "¡Excelente! Indícanos tu correo y la cantidad de planificaciones a cotizar y te enviaremos la cotización.",
          type: "inputs",
          answersLoaded: true,
          answers: [
            {
              name: "email",
              type: "email",
              placeholder: "Escribe tu correo aquí",
              class: "col-12 col-md-6 mb-2",
            },
            {
              name: "applications",
              type: "number",
              placeholder: "Cantidad de planificaciones",
              class: "col-12 col-md-6 mb-2",
            },
          ],
          nextMessage: "Obtener cotización!",
          extraFunction: (data) => {
            informationService
              .sendEurekaBill({
                email: data.email,
                applications: data.applications,
                service: "PLANI",
              })
              .then((resp) => {
                this.$toasted.success(resp.message);
              });
          },
          nextQuestionIndex: "mainMessage",
          routine: () => {},
        },
        video: {
          name: "video",
          text: "Mira el tutorial de las planificaciones antes de usarlas!",
          type: "informative",
          nextQuestionIndex: "mainMessage",
          answers: [],
          process_dic: [
            {
              text() {
                return "Recomendamos ver el video hasta el final antes de continuar";
              },
              video: "https://www.youtube.com/embed/qqPwn9SR7ng",
            },
          ],
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                this.process_dic.forEach((ans) => {
                  this.answers.push({
                    text: ans.text(),
                    video: ans.video,
                    class: "col-12 col-md-12 mb-2",
                  });
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
            // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
          },
        },
        type: {
          name: "type",
          text: `👋 Hola ${this.$store.state.login.first_name}! Hagamos una planificación de clase. Elige el estilo de planificación`,
          type: "cards",
          nextQuestionIndex: "period",
          answers: [
          {
              title: "Diversificado",
              name: "Actividades con Diseño Universal (DUA)",
              cols: "col-6",
              bootstrap_classes: "text-center",
              isSelected: false,
              option: "accurate",
              nextQuestionIndex: "period",
            },
          ],
          single_choice: true,
          vueContext: this,
          process_dic: [
            {
              text(template) {
                return (
                  "Descarga el Manual haciendo <a href='" +
                  template +
                  "' target='_blank' rel='noopener'>click aquí</a>"
                );
              },
              image: require("@/assets/img/eureka_chatbot_icons/mini_portada_manual.png"),
              width: "300",
            },
            {
              text() {
                return "Recomendamos ver el video hasta el final antes de continuar";
              },
              video: "https://www.youtube.com/embed/V7868MKYvz8",
            },
          ],
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                this.process_dic.forEach((ans) => {
                  this.answers.push({
                    title: ans.title,
                    text: ans.text(this.vueContext.template),
                    image: ans.image,
                    width: ans.width,
                    video: ans.video,
                    class: "col-12 col-md-12 mb-2",
                  });
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
          },
        },
        period: {
          name: "period",
          text: `¿Qué tipo de planificación necesitas?`,
          type: "cards",
          answersLoaded: true,
          nextQuestionIndex: "curso",
          single_choice: true,
          answers: [
            {
              title: "Planificación",
              name: "Diaria",
              cols: "col-6",
              isSelected: false,
              bootstrap_classes: "text-center",
              option: "daily",
              nextQuestionIndex: "curso",
            },
            // {
            //   title: "Intermedio",
            //   name: "Lo mejor de ambos mundos",
            //   cols: "col-sm-4",
            //   bootstrap_classes: "text-center",
            //   isSelected: false,
            //   option: "hybrid",
            // },
            // {
            //   title: "Planificación",
            //   name: "Mensual",
            //   cols: "col-6",
            //   bootstrap_classes: "text-center",
            //   isSelected: false,
            //   option: "monthly",
            //   nextQuestionIndex: "curso",
            // },
          ],
          routine: () => {
            // let selectedAnswer = this.currentQuestion.answers.find(
            //   (ans) => ans.isSelected
            // );
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
            console.log("routine");
          },
        },
        curso: {
          name: "curso",
          text: `👋 Hola ${this.$store.state.login.first_name}! Hagamos una planificación de clase. \n Dime ¿Con qué curso vamos a comenzar?`,// ¡Perfecto ${this.$store.state.login.first_name}! \n Dime ¿Con qué curso vamos a comenzar?`,
          hint: "Escoge solo un curso",
          type: "options",

          answersLoaded: false,
          single_choice: true,
          nextQuestionIndex: "asignatura",
          answers: [],
          process_dic: {
            "Pre-kinder": "PK",
            Kinder: "K",
            "1° básico": "1°",
            "2° básico": "2°",
            "3° básico": "3°",
            "4° básico": "4°",
            "5° básico": "5°",
            "6° básico": "6°",
            "7° básico": "7°",
            "8° básico": "8°",
            "1° medio": "1°M",
            "2° medio": "2°M",
            "3° medio": "3°M",
            "4° medio": "4°M",
          },
          getAnswers() {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                informationService.getPieGrades().then((data) => {
                data["grades"]
                  .filter((g) => ![14, 15, 16].includes(g[0]))
                  .forEach((ans) => {
                    this.answers.push({
                      original_name: ans[1],
                      name: this.process_dic[ans[1]],
                      code: ans[0],
                      isSelected: false,
                      cols: "col-sm-2 col-3",
                      bootstrap_classes: "font-weight-bold",
                      nextQuestionIndex: "asignatura",
                    });
                  });
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
            // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
          },
        },
        asignatura: {
          name: "asignatura",
          text: "¡Muy bien! Ahora dime ¿Con qué asignatura?",
          hint: "Escoge solo una asignatura",
          type: "options",
          answersLoaded: false,
          nextQuestionIndex: "oa",
          answers: [],
          single_choice: true,
          process_dic: {
            "Lenguaje y comunicación / Lengua y Literatura": "Lenguaje",
            Matemáticas: "Matemáticas",
            "Modelo ecológico funcional": "Modelo ecológico funcional",
            Música: "Música",
            "Historia, geografía y ciencias sociales": "Historia",
          },
          getAnswers(context) {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                customTestService
                .getSubjectHashtags(context.curso.original_name)
                .then((data) => {
                  data
                    //.filter((s) => [7, 29, 61, 8, 4].includes(s[0]))
                    .forEach((ans) => {
                      this.answers.push({
                        name: ans.name, // this.process_dic[ans[1]],
                        code: ans.id,
                        isSelected: false,
                        cols: "col-6",
                        nextQuestionIndex:
                          context.period.option === "daily"
                            ? "single_oa"
                            : "oa",
                      });
                    });
                  this.answersLoaded = true;
                  resolve(this.answers);
                });
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
            // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
            // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
          },
        },
        oa: {
          name: "oa",
          text: (context) => {
            const curso = context.curso.original_name;
            const asignatura = context.asignatura.name;

            return `Estos son los objetivos de aprendizaje de ${curso} para  ${asignatura}<br> ¿Cuáles te gustaría trabajar?`;
          },
          hint: () => {
            // const appleIcon = this.appleIcon;
            const starIcon = this.starIcon;

            return `Escoge tus objetivos de aprendizaje. <br> Las <img src='${starIcon}' width='22px' class='pl-1 mb-2'/></img> indican los OAs prioritarios `; //<br> Cada OA cuesta 100 <img src='${appleIcon}' width='22px' class='pl-1 mb-2'/></img>`;
          },
          type: "options",
          answersLoaded: false,
          answers: [],
          nextQuestionIndex: "indicadores",
          single_choice: false,
          getAnswers(context) {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                chatBotService.getPrice({ code: "OA" }).then((prices) => {
                customTestService
                  .getTagsFiltered(context.asignatura.code)
                  .then((d) => {
                    d.sort((a, b) => a.priority - b.priority).forEach((ans) => {
                      let short_name = ans.name.split(" ").slice(-1);
                      let extraText = ans.summary
                        ? ans.summary
                        : ans.description;
                      this.answers.push({
                        name:
                          "<strong style='font-size: 1.2rem;'>" +
                          short_name +
                          "</strong> - " +
                          extraText,
                        description: ans.description,
                        isSelected: false,
                        price: prices[0].price,
                        cols: "col-sm-12 col-12",
                        subtags: ans.subtags,
                        bootstrap_classes: "text-left px-2",
                        priority: ans.priority,
                      });
                    });
                    this.answersLoaded = true;
                    resolve(this.answers);
                  });
                });
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },

          routine() {
            console.log("routine");
            // this.currentQuestionIndex = this.nextQuestionIndex;
          },
        },
        single_oa: {
          name: "single_oa",
          text: (context) => {
            const curso = context.curso.original_name;
            const asignatura = context.asignatura.name;

            return `Estos son los objetivos de aprendizaje de ${curso} para  ${asignatura}<br> ¿Cuáles te gustaría trabajar?`;
          },
          hint: () => {
            // const appleIcon = this.appleIcon;
            const starIcon = this.starIcon;

            return `Escoge tu objetivo de aprendizaje. <br> Las <img src='${starIcon}' width='22px' class='pl-1 mb-2'/></img> indican los OAs prioritarios`; // <br> Cada OA cuesta 100 <img src='${appleIcon}' width='22px' class='pl-1 mb-2'/></img>`;
          },
          type: "options",
          answersLoaded: false,
          answers: [],
          single_choice: true,
          getAnswers(context) {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                chatBotService.getPrice({ code: "OA" }).then((prices) => {
                customTestService
                  .getTagsFiltered(context.asignatura.code)
                  .then((d) => {
                    d.sort((a, b) => a.priority - b.priority).forEach((ans) => {
                      let short_name = ans.name.split(" ").slice(-1);
                      let extraText = ans.summary
                        ? ans.summary
                        : ans.description;
                      this.answers.push({
                        name:
                          "<strong style='font-size: 1.2rem;'>" +
                          short_name +
                          "</strong> - " +
                          extraText,
                        description: ans.description,
                        isSelected: false,
                        price: prices[0].price,
                        cols: "col-sm-12 col-12",
                        subtags: ans.subtags,
                        bootstrap_classes: "text-left px-2",
                        priority: ans.priority,
                        nextQuestionIndex: "proxy_ind",
                      });
                    });
                  });
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            } else {
              return Promise.resolve(this.answers);
            }
          },

          routine() {
            console.log("routine");
            // this.currentQuestionIndex = this.nextQuestionIndex;
          },
        },
        indicadores: {
          name: "indicadores",
          text: "Ahora, selecciona la cantidad de actividades.",
          hint: () => {
            return "";
            // const appleIcon = this.appleIcon;
            // return `Cada indicador cuesta 100 <img src='${appleIcon}' width='22px' class='pl-1 mb-2'/></img>`;
          },
          type: "options-counter",
          answersLoaded: true,
          nextQuestionIndex: "special_conditions",
          answers: [],
          getAnswers() {
            return new Promise((resolve) => {
              return chatBotService.getPrice({ code: "IND" }).then((prices) => {
                this.context.oa.forEach((ans) => {
                  let indicators = ans.subtags
                    .filter((s) => s.summary != null)
                    .map((i, index) => {
                      return {
                        name: `Ind. ${index + 1}: ${i.summary}`,
                        count: 0,
                        description: i.name,
                        price: prices[0].price,
                      };
                    });
                  if (indicators.length === 0) {
                    indicators = [
                      {
                        name: ans.description,
                        count: 0,
                        description: "",
                        price: 0,
                      },
                    ];
                  }
                  this.answers.push({
                    name_section: ans.name,
                    has_warning: true,
                    warning_text:
                      "Debes tener al menos dos actividades seleccionadas!",
                    key: "oaInds",
                    required: 2,
                    options: indicators,
                    cols: "col-12",
                    oaInds: 0,
                    description: ans.description,
                  });
                });
                resolve();
              });
            });
          },
          routine() {
            // let selectedAnswer = this.currentQuestion.answers.find(
            //   (ans) => ans.isSelected
            // );

            // iterar en answers y por cada answer iterar en options y eliminar los que tengan count 0 y también eliminar las answer con options vacíos

            this.answers.map((ans) => {
              ans.options = ans.options.filter((opt) => opt.count > 0);
              return ans.options.length > 0;
            });
          },
        },
        proxy_ind: {
          name: "proxy_ind",
          type: "proxy",
          single_choice: false,
          text: "",
          answersLoaded: false,
          nextQuestionIndex(answers) {
            if (answers.single_oa.subtags) {
              return "single_indicadores";
            }
            return "special_conditions";
          },
          routine() {
            console.log("routine");
          },
        },
        single_indicadores: {
          name: "single_indicadores",
          text: "Ahora, selecciona los indicadores para tu planificación.",
          hint: () => {
            return "";
            // const appleIcon = this.appleIcon;
            // return `Cada indicador cuesta 100 <img src='${appleIcon}' width='22px' class='pl-1 mb-2'/></img><br>Puedes elegir hasta 3 indicadores.`;
          },
          type: "options",
          single_choice: false,
          answersLoaded: false,
          max: 3,
          nextQuestionIndex: "special_conditions",
          answers: [],
          getAnswers(context) {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                chatBotService.getPrice({ code: "IND" }).then((prices) => {
                if (context.single_oa.subtags) {
                  let index = 0;
                  context.single_oa.subtags.forEach((i) => {
                    let short_name = `Ind. ${index + 1}: `;
                    index++;
                    this.answers.push({
                      name:
                        "<strong style='font-size: 1.2rem;'>" +
                        short_name +
                        "</strong> " +
                        i.summary,
                      description: i.name,
                      isSelected: false,
                      price: prices[0].price,
                      cols: "col-sm-12 col-12",
                      bootstrap_classes: "text-left px-2",
                      nextQuestionIndex: "special_conditions",
                    });
                  });
                }
                this.answersLoaded = true;
                resolve(this.answers);
              });
            });
            } else {
              return Promise.resolve(this.answers);
            }
          },
          routine() {
            console.log("routine");
          },
        },
        special_conditions: {
          name: "special_conditions",
          text: "¿Hay algo más que te gustaría agregar o personalizar para tu clase? Puedes incluir detalles sobre la temática, requisitos especiales o cualquier otro aspecto que desees.",
          type: "options",
          answersLoaded: false,
          single_choice: true,
          answers: [
            {
              name: "Sí",
              isSelected: false,
              nextQuestionIndex: "special_conditions_text",
              hasSpecialConditions: true,
            },
          ],
          getAnswers(context) {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                let planificationType = context.period.option;
                this.answers.push({
                  name: "No",
                  isSelected: false,
                  nextQuestionIndex:
                    planificationType === "daily"
                      ? "daily_planification"
                      : "planificacion",
                  hasSpecialConditions: false,
                });
                this.answersLoaded = true;
                resolve(this.answers);
              });
            }
          },
          routine() {
            console.log("routine");
          },
        },
        special_conditions_text: {
          name: "special_conditions_text",
          text: "Escribe aquí lo que deseas agregar",
          type: "input-text",
          answersLoaded: false,
          required: true,
          answers: [
            {
              name: "special_conditions_input",
              bootstrap_classes: "text-left px-2",
            },
          ],
          nextQuestionIndex: "daily_planification",
          getAnswers(context) {
            if (!this.answersLoaded) {
              return new Promise((resolve) => {
                let planificationType = context.period.option;
                this.nextQuestionIndex =
                  planificationType === "daily"
                    ? "daily_planification"
                    : "planificacion";
                this.answersLoaded = true;
                resolve(this.answers);
              });
            }
          },
          routine() {
            console.log("routine");
          },
        },
        daily_planification: {
          name: "daily_planification",
          text: "Muy bien. Esta es la planificación que has creado",
          type: "custom-component",
          answersLoaded: true,
          answers: [],
          component: PlanificationTable,
          // El PPT sigue armandose despues de que aparece la tabla: el boton de
          // continuar espera a que termine (ver esperandoComponente).
          esperarComponente: true,
          getAnswers() {
            return new Promise((resolve) => {
              resolve(this.answers);
            });
          },
          // isFinal: true,
          nextQuestionIndex: "mainMessage",
          routine: () => {}
        },
        planificacion: {
          name: "planificacion",
          text: "Muy bien. Esta es la planificación que has creado",
          type: "custom-component",
          answersLoaded: true,
          answers: [],
          component: PlanificationTable,
          // El PPT sigue armandose despues de que aparece la tabla: el boton de
          // continuar espera a que termine (ver esperandoComponente).
          esperarComponente: true,
          getAnswers() {
            return new Promise((resolve) => {
              resolve(this.answers);
            });
          },
          // isFinal: true,
          nextQuestionIndex: "mainMessage",
          routine: () => {}
        },
        meeting: meetingQuestion(),
        ...referralQuestions(this, "mainMessage", SERVICE),
        missions: {
          name: "missions",
          text: () => {
            return `<div class="text-left"><strong>Puedes conseguir usos gratis realizando las siguientes acciones!</strong>`;
          },
          type: "custom-component",
          answersLoaded: true,
          answers: [],
          component: MissionsView,
          dontShowNextButton: true,
          nextQuestionIndex: "mainMessage",
          routine: () => {},
        },
      },
      template: "",
    };
  },
  created() {
    // Se pregunta acá, al montar, y no cuando la persona abre el referido: el
    // guard que decide si el referido se ofrece (`referralRewardsKnownEmpty`)
    // sólo se enteraba dentro de la vista de invitar, o sea después del clic
    // que queremos evitar. Es idempotente por servicio y falla abierto.
    ensureReferralRewards(SERVICE);
    userService.get_user_data().then((data) => {
      this.$store.commit("login/setPlanificationsUses", data.planificationsUses, { root: true });
      this.currentQuestionIndex = "welcomeMessage";
      let question = this.questions[this.currentQuestionIndex];
      this.messages.push(question);
      this.context[question.name] = {};
      this.$store.commit("chatbot/clear");
    });
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex];
    },
    school() {
      return this.$store.state.login.school;
    },
    year() {
      return this.$store.state.login.year;
    },
  },
  methods: {
    updateCondition(condition) {
      this.condition = condition;
    },
    handleCardClick(answer, msgidx, ansidx, max) {
      if (this.messages[msgidx].name === this.currentQuestion.name) {
        this.selectCard(msgidx, ansidx, answer, max);
        this.selectAnswer();
      }
    },
    handleIncrease(opt, answer) {
      if (opt.price) {
        if (opt.count === 0) {
          if (this.cost + opt.price <= this.$store.state.login.points) {
            this.cost += opt.price;
            opt.count++;
            answer.oaInds++;
          } else {
            this.$toasted.error(
              "No cuentas con aportes suficientes para realizar esta acción!"
            );
          }
        } else {
          if (opt.count < 2) {
            opt.count++;
            answer.oaInds++;
          }
        }
      } else {
        opt.count++;
        answer.oaInds++;
      }
    },
    handleDecrease(opt, answer) {
      if (opt.count > 0) {
        if (opt.price && opt.count === 1) {
          this.cost -= opt.price;
          opt.count--;
          answer.oaInds--;
        } else {
          opt.count--;
          answer.oaInds--;
        }
      }
    },
    async continueChat() {
      // hacer switch para disstintos tipos de pregunta
      switch (this.currentQuestion.type) {
        case "options":
          if (this.currentQuestion.single_choice) {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.find((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answer",
              value: this.context[this.currentQuestion.name],
            });
            if (this.context[this.currentQuestion.name].redirect) {
              window.location.href = this.context[this.currentQuestion.name].redirect;
            }
          } else {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name],
            });
          }
          break;
        case "options-counter":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;

        case "cards":
          if (this.currentQuestion.single_choice) {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.find((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answer",
              value: this.context[this.currentQuestion.name],
            });
          } else {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name],
            });
          }
          break;
        case "hybrid-options":
          // si optionalCheckbox es true, entonces type es option-counter si no, es multiple choice como cards
          if (this.currentQuestion.optionalCheckbox) {
            this.context[this.currentQuestion.name].answers =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name].answers,
            });
          } else {
            this.context[this.currentQuestion.name].answers =
              this.currentQuestion.answers.filter((ans) => ans.count > 0);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name].answers,
            });
          }
          break;
        case "text-area":
          this.context[this.currentQuestion.name].textInput =
            this.currentQuestion.textInput;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "textInput",
            value: this.context[this.currentQuestion.name].textInput,
          });
          break;
        case "selector-options":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        case "material":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        case "multiple-text":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        default:
          break;
      }

      this.messages.slice(-1)[0].answered = true;
      if (!this.currentQuestion.isFinal) {
        await this.currentQuestion.routine();
        // update store if the method updateStore exists in the question
        if (this.currentQuestion.updateStore) {
          this.currentQuestion.updateStore(this.context);
        }
        if (!this.currentQuestion.single_choice) {
          if (typeof this.currentQuestion.nextQuestionIndex === "function") {
            this.currentQuestionIndex = this.currentQuestion.nextQuestionIndex(
              this.context
            );
          } else {
            this.currentQuestionIndex = this.currentQuestion.nextQuestionIndex;
          }
        } else {
          this.currentQuestionIndex =
            this.context[this.currentQuestion.name] &&
            this.context[this.currentQuestion.name].nextQuestionIndex
              ? this.context[this.currentQuestion.name].nextQuestionIndex
              : this.currentQuestion.nextQuestionIndex;
        }
        if (this.currentQuestionIndex == "reset") {
          this.resetChat();
        }
        else if (this.currentQuestion.type === "proxy") {
          this.currentQuestionIndex = this.currentQuestion.nextQuestionIndex(this.context);
          this.loadQuestion(this.currentQuestionIndex);
        }
        else {
          this.loadQuestion(this.currentQuestionIndex);
        }
        this.context["currentQuestionIndex"] = this.currentQuestionIndex;
        this.$store.commit("chatbot/updateMessage", {
          name: "currentQuestionIndex",
          key: "value",
          value: this.currentQuestionIndex,
        });
      }
    },
    selectCard(msgidx, answeridx, answer, max) {
      if (this.currentQuestion.single_choice) {
        this.messages[msgidx].answers.forEach((ans) => {
          if (ans.price && ans.isSelected) {
            this.cost -= ans.price;
          }
          ans.isSelected = false;
        });
      }
      if (answer.price && !answer.isSelected) {
        if (this.cost + answer.price <= this.$store.state.login.points) {
          if (
            !max ||
            (max &&
              this.messages[msgidx].answers.filter((ans) => ans.isSelected)
                .length < max)
          ) {
            this.cost += answer.price;
            answer.isSelected = true;
          } else {
            this.$toasted.error(
              "Ya has seleccionado el máximo de " + max + " elementos"
            );
          }
        } else {
          this.$toasted.error(
            "No cuentas con aportes suficientes para realizar esta acción!"
          );
        }
      } else {
        if (answer.price && answer.isSelected) {
          this.cost -= answer.price;
        }
        if (
          answer.isSelected ||
          !max ||
          (max &&
            this.messages[msgidx].answers.filter((ans) => ans.isSelected)
              .length < max)
        ) {
          this.messages[msgidx].answers[answeridx].isSelected =
            !this.messages[msgidx].answers[answeridx].isSelected;
        } else {
          this.$toasted.error(
            "Ya has seleccionado el máximo de " + max + " elementos"
          );
        }
      }
    },
    resetValues() {
      this.selectedCard = null;
    },

    setText(sourceObj, keyObj, targetObj, keyTarget) {
      return new Promise((resolve) => {
        // resolve content
        let content =
          typeof sourceObj[keyObj] === "function"
            ? sourceObj[keyObj]()
            : sourceObj[keyObj];

        // type effect
        let i = 0;
        // targetObj[keyTarget] = "";
        let timer = setInterval(() => {
          if (i < content.length && content.charAt(i)) {
            targetObj[keyTarget] += content.charAt(i);

            i++;

            this.$forceUpdate();
          } else {
            clearInterval(timer);
            resolve();
          }
        }, 1);
      });
    },
    loadQuestion(questionIndex) {
      try {
        let question = this.questions[questionIndex];
        this.context[question.name] = {};
        this.messages.push(question);
      } catch (error) {
        console.log(error);
      }
    },

    selectAnswer() {
      if (this.currentQuestion.single_choice) {
        this.continueChat();
      }
    },
    scrollToBottom() {
      // `.global-container` es mas alto que la ventana: pasar su scrollHeight
      // como coordenada de `window` mandaba el scroll de largo.
      scrollToPageBottom();
    },

    scrollToMsg(name) {
      if (skipAutoScroll(this.messages, name)) return;
      const msgRef = this.$refs[`msgRef-${name}`];
      if (!msgRef || !msgRef.length) return;
      const el = msgRef.at(-1).$el;
      const parentMsg = el && el.parentNode;
      if (!parentMsg || !parentMsg.getBoundingClientRect) return;

      // Antes: scrollIntoView({ block: "center" }). Centrar funciona con
      // mensajes cortos, pero el paso de la planificacion monta la tabla y las
      // slides dentro de un mismo mensaje: ese bloque mide varias pantallas y
      // centrarlo dejaba al usuario en su mitad —pasada la tabla, sobre las
      // slides todavia vacias—. Se sube al inicio del mensaje, descontando el
      // header fijo para que el titulo no quede tapado.
      scrollToElementTop(parentMsg);
    },
    resetChat() {
      // this.messages = [];
      // this.answers = {};
      // this.currentQuestionIndex = "type";
      // this.loadQuestion(this.currentQuestionIndex);
      this.$emit("toggle-reload");
    },
    handleCheckbox(msgidx, value) {
      this.messages[msgidx].optionalCheckbox = value;
      this.context[this.currentQuestion.name].optionalCheckbox = value;
    },
    setTextInput(msgidx, value) {
      this.messages[msgidx].textInput = value;
      this.context[this.currentQuestion.name].textInput = value;
    },
    handleSelectorChange(msgidx, idx, value) {
      this.messages[msgidx].answers[idx].selected = value;
      this.context[this.currentQuestion.name].answers =
        this.messages[msgidx].answers;
    },
  },
  watch: {
    cost(val) {
      this.$emit("set-cost", val);
    },
  },
};
</script>
<style>
.global-container {
  margin: 0;
  padding: 0;
  min-height: 100%;
}

.image-container {
  background-image: url("../../assets/img/botpie/mancha.svg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center bottom;
}

.chat-box {
  margin: 10px;
  width: 100vw;
  margin-left: auto;
  margin-right: auto;
  align-items: space-between;
  justify-content: space-between;
}

/* RESET BUTTON */
/* CONTINUE BUTTON */
.reset-button {
  border-radius: 5px;
  border: 2pt solid rgb(0, 0, 0) !important;
  font-family: "Ubuntu Medium", Arial, sans-serif;
  font-weight: bold; /* Aplica negrita al texto */
  cursor: pointer;
}
</style>
